import OlympicQuiz from "../../App/OlympicQuiz";
import PotMemo from "../../App/PotMemo";
import OlympicMemo from "../../App/OlympicMemo";
import SportQuiz from "../../App/SportQuiz";
import NatureQuiz from "../../App/NatureQuiz";
import BrandsMemo from "../../App/BrandsMemo";
import BrandsQuiz from "../../App/BrandsQuiz";
import TouristQuiz from "../../App/TouristQuiz";
import PotQuiz from "../../App/PotQuiz";
import ThemeFactory from "../Theme/ThemeFactory";
import Safety from "../../App/Safety";
import FirstAidKit from "../../App/FirstAidKit";

export interface Route {
    id : string
    title : string
    hidden? : boolean
    load : () => JSX.Element
}

const routes : Route[] = [
    {
        id : "sport-quiz",
        title : "Quiz sportowy",
        load : () => <OlympicQuiz />,
    },
    {
        id : "sport-memo",
        title : "Memory sportowe",
        load : () => <OlympicMemo />,
    },
    {
        id : "pot-memo",
        title : "Memory Polska Organizacja Turystyczna",
        load : () => <PotMemo />,
    },
    {
        id : "sport-emotions",
        title : "Sportowe emocje",
        load : () => <SportQuiz />,
    },
    {
        id : "listen-nature",
        title : "Wsłuchaj się w naturę",
        load : () => <NatureQuiz />,
    },
    {
        id : "polish-brands-memo",
        title : "Memory Polskie Marki Turystyczne",
        load : () => <BrandsMemo />,
    },
    {
        id : "polish-brands-quiz",
        title : "Quiz Polskie Marki Turystyczne",
        load : () => <BrandsQuiz />,
    },
    {
        id : "tourist-quiz",
        title : "Quiz turystyczny",
        load : () => <TouristQuiz />,
    },
    {
        id : "pot-quiz",
        title : "Quiz Polska Organizacja Turystyczna",
        load : () => <PotQuiz />,
    },
    {
        id : "safety",
        title : "Bezpieczna turystyka",
        load : () => <Safety />
    },
    {
        id : "first-aid-kit",
        title : "Apteczka",
        hidden : true,
        load : () => <FirstAidKit />
    }
]

export class Router {

    static resolveFromLocation() : JSX.Element {
        return this.resolve(window.location.pathname.replace(/\//, ''))
    }

    static resolve(path : string) : JSX.Element {
        path = path.split('/').pop()
        ThemeFactory.tableVersion = path.startsWith('tv-') || path === 'tv'
        path = path.replace('tv-','')
        if(path === '' || path === 'tv') {
            return <DefaultPage tableVersion={ThemeFactory.tableVersion} />
        }
        const route = routes.find(r => r.id === path)
        return route ? route.load() : <NotFound />
    }
}

function DefaultPage(props: { tableVersion: boolean }) {
    return <div className="page-start">
        <ul>{routes.filter(r => r.hidden === undefined || r.hidden === false).map(r =>
            <li key={r.id}><a href={(props.tableVersion ? "tv-" : "") + r.id}><img src={"images/" + r.id + "/icon.png"} alt="Ikona" />{r.title}</a></li>
        )}</ul>
    </div>
}

function NotFound() {
    return <>Brak takiej strony</>;
}
